/**
 * Lightweight inline markdown renderer for **bold**, *italic*, and `code`.
 */
import { FC, ReactNode } from 'react'

export const InlineMd: FC<{ children?: string | null }> = ({ children }) => {
  if (!children || typeof children !== 'string') return null
  const parts: ReactNode[] = []
  const regex = /\*\*(.+?)\*\*|\*(.+?)\*|`(.+?)`/g
  let last = 0
  let match: RegExpExecArray | null

  while ((match = regex.exec(children)) !== null) {
    if (match.index > last) parts.push(children.slice(last, match.index))
    if (match[1]) parts.push(<strong key={match.index}>{match[1]}</strong>)
    else if (match[2]) parts.push(<em key={match.index}>{match[2]}</em>)
    else if (match[3]) parts.push(
      <code key={match.index} className="text-[10px] bg-muted px-1 py-0.5 rounded">
        {match[3]}
      </code>
    )
    last = regex.lastIndex
  }
  if (last < children.length) parts.push(children.slice(last))
  return parts.length > 0 ? <>{parts}</> : <>{children}</>
}
